<template>
  <div>
    <p class="old-publisher-info" v-if="currentSubjectCondition.code === 'ch1'">旧教科書の地理1の問題登録はございません</p>
    <p class="old-publisher-info" v-if="currentSubjectCondition.code === 're1'">旧教科書の歴史1の問題登録はございません</p>
    <v-radio-group
      v-model="selectedPublisherId"
      hide-details
      row
    >
      <v-radio
        v-for="(publisher, index) in publishers"
        :key="index"
        :label="publisher.name"
        :value="publisher.id"
        color="secondary"
        :disabled="disabled"
      />
    </v-radio-group>
  </div>
</template>

<script>
import teacher from '../../mixins/teacher';

export default {
  mixins: [teacher],

  props: {
    disabled: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    currentSubjectCondition() {
      return this.$store.state.top.currentSubjectCondition
    },

    publishers() {
      if (['ch1', 'ch2', 're1', 're23', 'mi'].includes(this.currentSubjectCondition.code)) {
        return this.$store.state.master.allSubjects.find(subject => subject.code === this.currentSubjectCondition.code).publishers
      }

      return this.$store.state.top.selectedSubject.publishers
    },

    selectedPublisherId: {
      get() {
        return this.currentSubjectCondition.selectedPublisher?.id
      },
      set(value) {
        this.$store.commit(
          'changeCurrentSubjectCondition',
          { selectedPublisher: this.publishers.find(publisher => publisher.id === value) }
        )
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
.v-label
  font-weight bold
.old-publisher-info
  font-size 14px
</style>
